/**
 * TODO add root as parameter and consider others
 */
export const observeIntersection = (callback, options) => new IntersectionObserver(callback, options);
export const observeSize = (callback) => new ResizeObserver(callback);
export const observeMutation = (callback) => new MutationObserver(callback);
export const disconnect = (observer) => observer.disconnect();
export const takeRecords = (observer) => observer.takeRecords();
export const unobserve = (observer, target) => observer.unobserve(target);
export { observe };
function observe(observer, element, options) {
    // @ts-expect-error
    observer.observe(element, options);
}
